import React from 'react'
import * as styles from './IncommOfferBanner.module.scss'
import { formatStepImageUrl } from 'util/beaker2-step-image-url'

const mockIncommOfferBanner = {
  title: 'MaYO Game Day Be Delicious',
  description: `Score $2 off Hellmann’s® With This Exciting Reward! Whether you're tailgating at the stadium or cheering from the couch, Hellmann's® is your secret weapon for winning snacks.`,
  backgroundImageUrl:
    'https://res.cloudinary.com/dbgu1ncmk/image/upload/v1757033741/9dab64a80d38abc93a890999c3fde9b8cb929cbb_wcy5pj.png',
}

interface IncommOfferBannerProps {
  title: string
  description: string
  backgroundImageUrl: string
}

export const IncommOfferBanner = ({
  title = mockIncommOfferBanner.title,
  description = mockIncommOfferBanner.description,
  backgroundImageUrl = mockIncommOfferBanner.backgroundImageUrl,
}: IncommOfferBannerProps) => {
  // Determine if backgroundImageUrl is a path, UUID, or full URL
  // UUIDs: "febc10d0-abd0-4dc0-9be3-dd02c1e7d765" (no slashes, UUID format)
  // Paths: "incomm-offers/banner.jpg" (contains slashes)
  // Full URLs: "https://..." (starts with http)

  let imageUrl = formatStepImageUrl(backgroundImageUrl)

  return (
    <div className={styles.incommOfferBanner}>
      <div
        dangerouslySetInnerHTML={{ __html: title }}
        className={styles.incommOfferBannerTitle}
      />
      <div
        dangerouslySetInnerHTML={{ __html: description }}
        className={styles.incommOfferBannerDescription}
      />
      {imageUrl && (
        <img
          src={imageUrl}
          alt={title}
          className={styles.incommOfferBannerImage}
          onError={e => {
            console.error('❌ Failed to load image:', imageUrl)
            console.error('Original value was:', backgroundImageUrl)
          }}
        />
      )}
    </div>
  )
}
